import { ReactComponent as XIcon } from "../../../assets/svg/xIcon.svg";
import React from "react";

type AlertType = "error" | "warning" | "info" | "success";

interface IAlertProps {
	text: string; // HTML string or plain text
	type: AlertType;
	onClose?: () => void;
	isHTML?: boolean; // Toggle for HTML rendering
}

const Alert: React.FC<IAlertProps> = ({ text, type, onClose, isHTML }) => {
	const processHTML = (html: string) => {
		// Add hover styles to <a> tags
		return html.replace(
			/<a\s+(.*?)>/g,
			`<a $1 style="color: blue; text-decoration: underline;" target="_blank" rel="noopener noreferrer">`
		);
	};

	return (
		<blockquote
			className={`w-full p-1 border-s-8 ${
				type === "error"
					? "border-red-500 bg-rose-200"
					: type === "warning"
						? "border-yellow-600 bg-yellow-200"
						: type === "info"
							? "border-blue-500 bg-blue-200"
							: "border-green-500 bg-green-200"
			} drop-shadow-lg`}
		>
			<div className="flex items-center justify-between p-2">
				{isHTML ? (
					<p
						className="font-Poppins font-medium leading-normal text-center text-md text-sky-800"
						dangerouslySetInnerHTML={{
							__html: processHTML(text),
						}}
					/>
				) : (
					<p className="font-Poppins font-medium leading-normal text-center text-md text-sky-800">
						{text}
					</p>
				)}
				{onClose && (
					<button
						className="text-gray-500 rounded-full shadow-md hover:text-gray-600"
						onClick={onClose}
					>
						<XIcon className="w-6 h-6" />
					</button>
				)}
			</div>
		</blockquote>
	);
};

export default Alert;
